// Single source of truth for topic catalog.
// Keep slugs in sync with public.allowed_topics() in Postgres.

export interface TopicDef {
  slug: string;
  label: string;
  hint: string;
}

export const TOPICS: TopicDef[] = [
  { slug: "foundation-models", label: "Foundation Models", hint: "GPT, Claude, Gemini, Llama" },
  { slug: "open-source", label: "Open Source", hint: "Weights, licenses, forks" },
  { slug: "coding-ides", label: "Coding & IDEs", hint: "Cursor, Copilot, Lovable" },
  { slug: "agents", label: "Agents", hint: "Autonomous workflows, tool use" },
  { slug: "robotics", label: "Robotics", hint: "Humanoids, embodied AI" },
  { slug: "hardware-gpus", label: "Hardware & GPUs", hint: "Nvidia, TPUs, data centers" },
  { slug: "image-video-gen", label: "Image & Video Gen", hint: "Sora, Veo, Midjourney" },
  { slug: "voice-audio", label: "Voice & Audio", hint: "TTS, music, podcasts" },
  { slug: "search-rag", label: "Search & RAG", hint: "Perplexity, retrieval" },
  { slug: "enterprise-saas", label: "Enterprise & SaaS", hint: "B2B, deployments" },
  { slug: "startups-funding", label: "Startups & Funding", hint: "Rounds, valuations, M&A" },
  { slug: "big-tech", label: "Big Tech", hint: "OpenAI, Google, Meta, Anthropic" },
  { slug: "china-ai", label: "China AI", hint: "DeepSeek, Qwen, Alibaba" },
  { slug: "regulation-lawsuits", label: "Regulation & Lawsuits", hint: "EU AI Act, copyright" },
  { slug: "safety-alignment", label: "Safety & Alignment", hint: "Risks, jailbreaks, policy" },
  { slug: "jobs-economy", label: "Jobs & Economy", hint: "Layoffs, automation, productivity" },
  { slug: "science-research", label: "Science & Research", hint: "Papers, breakthroughs" },
  { slug: "creative-tools", label: "Creative Tools", hint: "Design, writing, art" },
  { slug: "crypto-ai", label: "Crypto × AI", hint: "On-chain agents, GPU networks" },
  { slug: "geopolitics", label: "Geopolitics", hint: "Export controls, US/China" },
];

export const TOPIC_SLUGS = TOPICS.map((t) => t.slug);
export const MIN_TOPICS = 3;
export const MAX_TOPICS = 7;
